import { Link } from "react-router-dom"
import "./Notfound.css";

export const NotFound = () => {
    return <section id="notfound">
        <h2>Page not found</h2>

        <Link to="/">Go home</Link>
    </section>
}